module.exports = __webpack_public_path__ + "static/media/DTUK-26-Conference-LOGO-white.88d2f450.png";